import { fetchResources as fetchCountries } from "@apiWeb/countries";
import { useCountryStore } from "@modelStores/country-store";

/**
 * useFetchCountries — pre-fetch all countries into store.
 *
 * Call `fetchAllCountries()` in initializer to populate country-store globally.
 */
export function useFetchCountries() {
  const countryStore = useCountryStore();

  const fetchAllCountries = () => {
    return fetchCountries({ page: { size: 100 }, sort: "position" });
  };

  return {
    countryStore,
    fetchAllCountries,
  };
}
